const defaultTheme = require('tailwindcss/defaultTheme')

module.exports = {
  theme: {
    fontFamily: {
      body: ['Poppins', 'sans-serif'],
      serif: ['serif']
    },
    extend: {
      screens: {
        print: { raw: 'print' }
      },
      colors: theme => {
        const Color = require('color')
        const opacities = [25, 50, 75]
        const result = {}
        const { colors } = defaultTheme
        for (let colorKey in colors) {
          if (typeof colors[colorKey] !== 'string') {
            for (let colorShade in colors[colorKey]) {
              for (let opacity of opacities) {
                result[`${colorKey}-${colorShade}-${opacity}`] = Color(colors[colorKey][colorShade])
                  .alpha(opacity / 100)
                  .string()
              }
            }
          }
        }

        result[`sigma-green-dark`] = '#006369'
        result[`sigma-green`] = '#00948c'
        result[`sigma-green-light`] = '#8cc5c5'

        for (let opacity of opacities) {
          result[`sigma-green-dark-${opacity}`] = Color(result[`sigma-green-dark`])
            .alpha(opacity / 100)
            .string()
          result[`sigma-green-${opacity}`] = Color(result[`sigma-green`])
            .alpha(opacity / 100)
            .string()
          result[`sigma-green-light-${opacity}`] = Color(result[`sigma-green-light`])
            .alpha(opacity / 100)
            .string()
        }

        return result
      },
      padding: {
        full: '100%'
      },
      inset: {
        50: '50%'
      },
      width: {
        '1/2-screen': '50vw',
        '100': '100px',
        '200': '200px',
        '300': '300px',
        '400': '400px',
        '500': '500px',
        '150': '150px',
        '250': '250px',
        '350': '350px',
        '450': '450px',
        '550': '550px'
      },
      height: {
        '1/2-screen': '50vh',
        '100': '100px',
        '200': '200px',
        '300': '300px',
        '400': '400px',
        '500': '500px',
        '150': '150px',
        '250': '250px',
        '350': '350px',
        '450': '450px',
        '550': '550px'
      },
      maxWidth: {
        '1/2': '50%',
        '1/3': 'calc(100%/3)'
      },
      maxHeight: {
        '1/2': '50%',
        '1/3': 'calc(100%/3)'
      },
      zIndex: {
        '-1': -1
      },
      borderWidth: {
        '64': '10vw'
      },
      fontSize: {
        '7xl': '5rem',
        '8xl': '6rem'
      }
    }
  },
  variants: {
    opacity: ['hover']
  },
  plugins: []
}
